<template>
  <div class="effect-scene">
    <!-- logotype -->
    <div class="effect-scene__logotype">
      <h1>選戰蝴蝶效應</h1>
      <SvgSymbol use="#effect-logotype"/>
    </div>

    <!-- scenario -->
    <div class="effect-scene__scenario">
      <div class="effect-scene__landscape"><!--
      --><div class="effect-scene__landscape-party effect-scene__landscape-dpp"></div><!--
      --><div class="effect-scene__landscape-party effect-scene__landscape-pfp"></div><!--
      --><div class="effect-scene__landscape-party effect-scene__landscape-kmt"></div>
      </div>
      <div class="effect-scene__reflection"></div>
      <div class="effect-scene__portrait"><!--
      --><div class="effect-scene__portrait-party effect-scene__portrait-dpp"></div><!--
      --><div class="effect-scene__portrait-party effect-scene__portrait-pfp"></div><!--
      --><div class="effect-scene__portrait-party effect-scene__portrait-kmt"></div>
      </div>
    </div>

    <!-- scroll -->
    <div class="effect-scene__scroll" title="往下捲動" @click="onScrollClick">
      <SvgSymbol class="effect-scene__scroll-icon" use="#arrow-down"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YouthScene',
  methods: {
    onScrollClick (event) {
      this.$ga('newmedia.send', {
        'hitType': 'event',
        'eventCategory': 'Click',
        'eventAction': 'Click',
        'eventLabel': `Scroll-to-topics`
      })
      this.$scrollTo('#articles', 500, { offset: -30 })
    }
  }
}
</script>

<style lang="scss">
.effect-scene {
  @include use-layer(&);
  position: relative;
  width: 100%;
  height: 90vh;
  max-height: 550px;
  background-image: linear-gradient(to top, rgb(232, 166, 135), rgb(243, 209, 138));
  @include rwd($RWD_TABLET_SMALL) {
    max-height: 730px;
  }
  @include rwd($RWD_TABLET) {
    max-height: 830px;
  }
  @include rwd($RWD_DESKTOP) {
    max-height: none;
  }

  &__logotype {
    z-index: 2;
    display: block;
    position: absolute;
    top: 90px;
    left: 50%;
    width: 70%;
    margin-left: -10px;
    transform: translateX(-50%);
    @include use-fixed-ratio(631, 316);
    @include rwd($RWD_TABLET_SMALL) {
      width: 425px;
    }
    @include rwd($RWD_TABLET) {
      width: 545px;
    }
    @include rwd($RWD_DESKTOP) {
      width: 475px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      width: 500px;
    }

    h1 {
      display: none;
    }

    .svg-symbol {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  &__scenario {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    @include rwd($RWD_IPHONE_678) {
    }
    @include rwd($RWD_TABLET_SMALL) {
    }
    @include rwd($RWD_TABLET) {
      $width: 700px;
      left: 50%;
      width: $width;
      margin-left: (-$width/2);
    }
    @include rwd($RWD_DESKTOP) {
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      $width: 885px;
      width: $width;
      margin-left: (-$width/2);
    }
  }

  &__landscape {
    position: relative;
    width: 100%;
    height: 100%;
    @include rwd($RWD_TABLET_SMALL) {
    }
    @include rwd($RWD_TABLET) {
    }
    @include rwd($RWD_DESKTOP) {
    }
    @include rwd($RWD_DESKTOP_WIDE) {
    }

    &-party {
      display: inline-block;
      position: relative;
      width: 33.33%;
      height: 100%;
      vertical-align: top;
    }

    &-dpp {
      background-image: linear-gradient(to top, rgb(189, 221, 167), rgb(191, 227, 168));
    }

    &-pfp {
      background-image: linear-gradient(to top, rgb(252, 179, 122), rgb(253, 184, 122));
    }

    &-kmt {
      background-image: linear-gradient(to top, rgb(161, 202, 225), rgb(162, 207, 225));
    }
  }

  $degree: -15deg;
  @keyframes light {
    0% {
      opacity: 0.1;
      transform: translateX(-12%) skewX($degree);
    }
    80% {
      opacity: 0.15;
      transform: translateX(40%) skewX($degree);
    }
    100% {
      opacity: 0.1;
      transform: translateX(12%) skewX($degree);
    }
  }

  &__reflection {
    $degree: -15deg;
    position: absolute;
    top: 0;
    left: 50%;
    width: 130px;
    margin-left: -65px;
    height: 100%;
    @include rwd($RWD_TABLET_SMALL) {
      width: 200px;
      margin-left: -100px;
    }

    &:before,
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: white;
      opacity: 0.1;
    }

    &:before {
      transform: translateX(-50%) skewX($degree);
      animation: light 6s infinite alternate both;
    }

    &:after {
      transform: translateX(50%) skewX($degree);
      animation: light 6s infinite alternate-reverse both;
    }
  }

  &__portrait {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    @include use-vertical-align();
    @include rwd($RWD_TABLET_SMALL) {
    }
    @include rwd($RWD_TABLET) {
    }
    @include rwd($RWD_DESKTOP) {
    }
    @include rwd($RWD_DESKTOP_WIDE) {
    }

    &-party {
      display: inline-block;
      position: relative;
      width: 33.33%;
      vertical-align: bottom;
      // outline: 1px solid cyan;
      background-repeat: no-repeat;
      background-size: contain;
      transform-origin: bottom center;
      @include rwd($RWD_TABLET_SMALL) {
        max-width: 200px;
      }
      @include rwd($RWD_DESKTOP_WIDE) {
        max-width: 230px;
      }
    }

    &-dpp {
      z-index: 2;
      @include use-fixed-ratio(379, 529);
      background-image: url(~@/assets/portrait-dpp.png);
      transform: translateX(-2%) scale(1.45);
      @include rwd($RWD_TABLET) {
        transform: translateX(-25%) scale(1.45);
      }
    }

    &-pfp {
      z-index: 1;
      @include use-fixed-ratio(360, 530);
      background-image: url(~@/assets/portrait-pfp.png);
      transform: translateX(-5%) scale(1.4);
    }

    &-kmt {
      z-index: 3;
      @include use-fixed-ratio(320, 497);
      background-image: url(~@/assets/portrait-kmt.png);
      transform: translateX(20%) scale(1.22);
    }
  }

  &__scroll {
    z-index: 3;
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 46px;
    height: 46px;
    margin-bottom: -23px;
    margin-left: -23px;
    color: white;
    text-align: center;
    background: #efefef;
    border: 2px solid #f6d18a;
    border-radius: 50%;
    user-select: none;
    cursor: pointer;
    @include use-vertical-align();
    @include rwd($RWD_TABLET_SMALL) {}
    @include rwd($RWD_TABLET) {}
    @include rwd($RWD_DESKTOP) {
      $size: 58px;
      width: $size;
      height: $size;
      margin-bottom: (-$size/2);
      margin-left: (-$size/2);
    }
    @include rwd($RWD_DESKTOP_WIDE) {}

    &:active {
      transform: translateY(2px);
    }

    &-icon {
      display: inline-block;
      width: 16px;
      height: 9px;
      color: #f6d18a;
      vertical-align: middle;
      @include rwd($RWD_DESKTOP) {
        width: 20px;
        height: 12px;
      }
    }
  }
}

.mobile {
  // .effect-scene {
  //   min-height: 100vh;
  // }
}

.narrow-desktop { // Inject by App.vue when viewport size 960&up + 768&down
  .effect-scene {
    max-height: 550px;

    &__logotype {
      top: 60px;
      width: 300px;
    }

    &__scenario {
      width: 450px;
      margin-left: -225px;
    }

    &__landscape {
    }

    &__portrait {
    }

    &__scroll {
    }
  }
}
</style>
